import { render } from "./IconHotel.vue?vue&type=template&id=e2aaeff4"
import script from "./IconHotel.vue?vue&type=script&lang=js"
export * from "./IconHotel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__